import React, { useState } from "react";
import screen1 from "../../assets/images/screen-1.png";
import { Link } from "react-router-dom";
import ModalVideo from "react-modal-video";
import '../../../node_modules/react-modal-video/scss/modal-video.scss'

const FunfactVideo = () => {
  const [isOpen, setIsOpen] = useState(false);

  const [dataBlock] = useState({
    title: "50k+ users are using this landing page.",
    subTitle:
      "  With lots of unique blocks, you can easily build a page without coding.",
  });
  return (
    <>
      <section className="md:mt-24 mt-10 relative pb-20 bg-themedark">
        <div className="bg-[url('../images/home_sec_video.png')] absolute inset-0 w-full"></div>
        <div className="container relative">
          <div className="grid grid-cols-1">
            <div className="max-w-[800px] mx-auto relative -top-[70px]">
              <button onClick={() => setIsOpen(true)} className="lightbox">
                <i className="mdi mdi-play w-[65px] h-[65px] leading-[65px] text-center text-[35px] absolute top-1/2 bg-custom left-1/2 z-10 rounded-full text-white -translate-y-1/2 -translate-x-1/2"></i>
              </button>
              <ModalVideo
                channel="youtube"
                isOpen={isOpen}
                videoId="YjhrligRTbE"
                onClose={() => setIsOpen(false)}
              />
              <img src={screen1} alt="screen1" className="" />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-[30px]">
            <div className="text-white max-w-[500px]">
              <h2 className="text-[35px] font-bold leading-[1.4]">
                {dataBlock.title}
              </h2>
              <p className="text-muted mt-6 mb-4 md:mb-0">
                {dataBlock.subTitle}
              </p>
            </div>
            <div className="md:text-right">
              <Link to="#" className="btn-custom">
                Download Now!
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FunfactVideo;
